import React from 'react';
import Nav from './nav';


function ComputerSciencePage(props) {
  return (
    <div>
      <Nav/>
      <br/>
      <p>Under construction, please check it later</p>
    </div>
  );
}
export default ComputerSciencePage;